module.exports = __webpack_public_path__ + "img/warrants_small.82b7c0ea.svg";